import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e3fadb58&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e3fadb58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fadb58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3fadb58')) {
      api.createRecord('e3fadb58', component.options)
    } else {
      api.reload('e3fadb58', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e3fadb58&scoped=true&", function () {
      api.rerender('e3fadb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tv6drpUt1QR7/JS/comp/GuestBox.vue"
export default component.exports